import { useContext, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { Container, Grid, Tooltip } from "@material-ui/core";
import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import AccordionAdicionais from "./children/AccordionAdicionais";
import AccordionDadosGerais from "./children/AccordionDadosGerais";
import AccordionInfoFaturamento from "./children/AccordionInfoFaturamento";
import AccordionInfoServico from "./children/AccordionInfoServico";
import {
  GerenciamentoContratoContext,
  GerenciamentoContratoContextProvider,
} from "./contexts/GerenciamentoContratoContext";
import useGerenciamentoContratoController from "./controllers/GerenciamentoContratoController";
import { ModalCancelamentoContrato } from "./children/ModalCancelamentoContrato";
import ModalEmailContact from "./children/ModalEmailContract";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { ModalReativarContrato } from "./children/ModalReativarContrato";
import { GlobalVariables } from "../../../GlobalVariables";
import { ConfigurationContext } from "./contexts/ConfigurationContext";

const View = ({ location }) => {
  const {
    loading,
    contractCanceled,
    contractStatus,
    openEmail,
    setLoading,
    setOpenEmail,
    clientInfos,
    idContract,
    modalCancelamentoContratoOpen,
    modalReativacaoContratoOpen,
    setModalReativacaoContratoOpen,
    setModalCancelamentoContratoOpen,
    itemsTable,
  } = useContext(GerenciamentoContratoContext);

  const { configuration } = useContext(ConfigurationContext);

  const bloqueadoPorPerfilTributario = useMemo(() => {
    if (configuration?.utiliza_nova_nfse !== 1) return false;
    return itemsTable?.some(
      (item) =>
        !(item.reasonForCancellationId || item.cancelDate) &&
        !item?.service?.perfil_tributario_id
    );
  }, [configuration?.utiliza_nova_nfse, itemsTable]);

  const {
    confirmEditContract,
    handleData,
    handleSuspensionContract,
    handleDownloadPdf,
  } = useGerenciamentoContratoController();

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  useEffect(() => {
    handleData(location?.state?.id);
  }, [location, handleData]);

  const renderBotaoSalvar = (salvarENovo) => {
    const btn = (
      <Btn
        label={salvarENovo ? "SALVAR E NOVO" : "SALVAR"}
        onClick={() =>
          confirmEditContract(
            location?.state?.id,
            salvarENovo,
            !!location?.state?.id
          )
        }
        bgcolor="tertiary"
        disabled={contractCanceled || bloqueadoPorPerfilTributario}
      />
    );
    if (bloqueadoPorPerfilTributario) {
      return (
        <Tooltip
          title={
            "Não é possível salvar: Existe(m) serviço(s) ativos sem perfil tributário configurado. Edite o item e selecione o perfil."
          }
        >
          <span style={{ display: "inline-block" }}>{btn}</span>
        </Tooltip>
      );
    }
    return btn;
  };

  return (
    <>
      {modalCancelamentoContratoOpen && (
        <ModalCancelamentoContrato
          open={modalCancelamentoContratoOpen}
          setOpen={setModalCancelamentoContratoOpen}
          labelModal="CANCELAR CONTRATO"
          contractId={location?.state?.id || null}
        />
      )}
      {modalReativacaoContratoOpen && (
        <ModalReativarContrato
          open={modalReativacaoContratoOpen}
          setOpen={setModalReativacaoContratoOpen}
          contractId={location?.state?.id || null}
          refreshFunction={() =>
            push("listagem?gfAccessToken=" + queryParams.gfAccessToken)
          }
        />
      )}
      {openEmail && (
        <ModalEmailContact
          modalOpen={openEmail}
          setModalOpen={setOpenEmail}
          modelo={{ idcliente: clientInfos?.id, id: idContract }}
          setMainLoading={setLoading}
        />
      )}
      <Loading open={loading} />
      <HeaderModule
        title={"GERENCIAMENTO DE CONTRATO DE SERVIÇO"}
        videoId={GlobalVariables.screenVideosIds.gerenciamentoContratoServico}
        receivedChild={
          <Grid
            item
            container
            xs={8}
            md={9}
            lg={10}
            spacing={1}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item xs={2}>
              <Btn
                style={{ width: "100%" }}
                fontSize="11px"
                label="CANCELAR"
                onClick={() => setModalCancelamentoContratoOpen(true)}
                bgcolor="red"
                disabled={
                  location?.state?.id && !contractCanceled ? false : true
                }
              />
            </Grid>
            <Grid item xs={2}>
              <Btn
                style={{ width: "100%" }}
                fontSize="11px"
                label="REATIVAR"
                onClick={() => setModalReativacaoContratoOpen(true)}
                bgcolor="green"
                disabled={!location?.state?.id || !contractCanceled}
              />
            </Grid>
            <Grid item xs={2}>
              <Btn
                style={{ width: "100%" }}
                fontSize="11px"
                label="SUSPENDER"
                onClick={() => handleSuspensionContract(location?.state?.id)}
                bgcolor="purple"
                disabled={
                  !(location?.state?.id && !["C", "S"].includes(contractStatus))
                }
              />
            </Grid>
            {location?.state?.id && (
              <Grid item xs={2}>
                <Btn
                  style={{ width: "100%" }}
                  fontSize="11px"
                  label="IMPRIMIR"
                  onClick={() => handleDownloadPdf(location?.state?.id)}
                  bgcolor="tertiary"
                />
              </Grid>
            )}
            {location?.state?.id && (
              <Grid item xs={4}>
                <Btn
                  style={{ width: "100%" }}
                  fontSize="11px"
                  label="ENVIAR POR E-MAIL"
                  onClick={() => {
                    setOpenEmail(true);
                  }}
                  bgcolor="tertiary"
                />
              </Grid>
            )}
          </Grid>
        }
      />
      <AccordionDadosGerais location={location} />
      <AccordionInfoServico location={location} />
      <Margin top="20">
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AccordionInfoFaturamento location={location} />
            </Grid>
            <Grid item xs={6}>
              <AccordionAdicionais />
            </Grid>
          </Grid>
        </Container>
      </Margin>
      <Margin top="30" bottom="30">
        <Container maxWidth="xl">
          <Grid item container xs>
            <Grid item container xs justifyContent="flex-end" spacing={2}>
              <Grid item>
                <Btn
                  label="VOLTAR"
                  onClick={() =>
                    push("listagem?gfAccessToken=" + queryParams.gfAccessToken)
                  }
                />
              </Grid>
              <Grid item>{renderBotaoSalvar(false)}</Grid>
              <Grid item>{renderBotaoSalvar(true)}</Grid>
            </Grid>
          </Grid>
        </Container>
      </Margin>
    </>
  );
};

const GerenciamentoContratoCadastro = ({ ...props }) => {
  return (
    <GerenciamentoContratoContextProvider>
      <View {...props} />
    </GerenciamentoContratoContextProvider>
  );
};

export default GerenciamentoContratoCadastro;
